(function (window) {
  'use strict';

  var THRESHOLD = 500000;
  function money(value) { return Number.isSafeInteger(value) && value >= 0; }
  function add(a, b) { var result = a + b; return money(result) ? result : null; }
  function id(value) {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
    return typeof value === 'string' && /^[1-9]\d*$/.test(value) ? value : null;
  }
  function remainingWholeRupees(netPaise, threshold) {
    return money(netPaise) ? Math.max(0, Math.floor((threshold - netPaise) / 100) + 1) : null;
  }
  function catalogue(config) {
    var gift = config && Array.isArray(config.gifts) && config.gifts[0];
    // One configured product only; stale extra entries must not broaden cleanup authority.
    return gift && typeof gift.variantId === 'string' && id(gift.variantId) ? [gift] : [];
  }
  function managed(line, config, entries) {
    return !!(line && config && typeof config.campaignId === 'string' && config.campaignId && line.properties &&
      line.properties[config.markerKey || '_apella_shagun'] === config.campaignId &&
      entries.some(function (gift) { return gift.variantId === id(line.variant_id || line.id); }));
  }
  function analyze(cart, config) {
    config = config || {};
    var entries = catalogue(config);
    var lines = cart && Array.isArray(cart.items) ? cart.items : [];
    var gifts = lines.filter(function (line) { return managed(line, config, entries); });
    var result = { valid: false, netPaise: null, gifts: gifts, otherDiscount: false, confirmedGift: null, reason: 'invalid-cart' };
    if (!cart || !Array.isArray(cart.items) || cart.currency !== 'INR' || config.currency !== 'INR') {
      result.reason = 'invalid-currency'; return result;
    }
    if (!money(cart.total_price) || !money(cart.total_discount)) { result.reason = 'invalid-money'; return result; }
    var excluded = Array.isArray(config.excludedProductIds) ? config.excludedProductIds : [];
    var applications = Array.isArray(cart.discount_applications) ? cart.discount_applications : [];
    var appGroups = [applications, Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []];
    var nativeTitle = typeof config.discountTitle === 'string' && config.discountTitle ? config.discountTitle : null;
    var duplicateNative = false;
    appGroups.forEach(function (group) {
      var count = 0;
      group.forEach(function (application) {
        if (!application) return;
        if (nativeTitle && application.title === nativeTitle) count += 1;
        else if (application.total_allocated_amount === undefined || application.total_allocated_amount > 0) result.otherDiscount = true;
      });
      if (count > 1) duplicateNative = true;
    });
    if (duplicateNative) result.otherDiscount = true;
    var totalFinal = 0;
    var excludedFinal = 0;
    var nativeAllocated = 0;
    var candidates = [];
    for (var i = 0; i < lines.length; i += 1) {
      var line = lines[i];
      if (!line || !Number.isSafeInteger(line.quantity) || line.quantity < 1 || !money(line.final_line_price) ||
          (line.original_line_price !== undefined && (!money(line.original_line_price) || line.original_line_price < line.final_line_price))) {
        result.reason = 'invalid-money'; return result;
      }
      var isGift = gifts.indexOf(line) !== -1;
      totalFinal = add(totalFinal, line.final_line_price);
      if (isGift || line.gift_card === true || excluded.indexOf(id(line.product_id)) !== -1) excludedFinal = add(excludedFinal, line.final_line_price);
      if (totalFinal === null || excludedFinal === null) { result.reason = 'invalid-money'; return result; }
      var original = line.original_line_price;
      var reduction = original === undefined ? 0 : original - line.final_line_price;
      var lineNative = 0;
      var seenAllocations = Object.create(null);
      var allocations = [];
      if (Array.isArray(line.line_level_discount_allocations)) allocations = allocations.concat(line.line_level_discount_allocations);
      if (Array.isArray(line.discount_allocations)) allocations = allocations.concat(line.discount_allocations);
      for (var j = 0; j < allocations.length; j += 1) {
        var allocation = allocations[j];
        if (!allocation || !money(allocation.amount)) { result.reason = 'invalid-discount-money'; return result; }
        var application = allocation.discount_application || applications[allocation.discount_application_index];
        var title = application && application.title;
        var allocationKey = JSON.stringify([title || '', allocation.amount, allocation.discount_application_index === undefined ? '' : allocation.discount_application_index]);
        if (seenAllocations[allocationKey]) continue;
        seenAllocations[allocationKey] = true;
        if (!allocation.amount) continue;
        if (nativeTitle && title === nativeTitle && isGift && !duplicateNative) {
          lineNative = add(lineNative, allocation.amount);
          nativeAllocated = add(nativeAllocated, allocation.amount);
          if (lineNative === null || nativeAllocated === null) { result.reason = 'invalid-discount-money'; return result; }
        } else result.otherDiscount = true;
      }
      // A marker cannot explain an actual price reduction on a paid line.
      if (reduction > 0 && (!isGift || reduction > lineNative)) result.otherDiscount = true;
      if (isGift && line.quantity === 1 && line.final_line_price === 0 && lineNative > 0 &&
          (original === undefined || lineNative === original)) candidates.push(line);
    }
    if (cart.total_price > totalFinal || cart.total_price < excludedFinal) { result.reason = 'inconsistent-cart-total'; return result; }
    // Ajax total_price includes cart-level discounts. Never recompute net from original prices.
    result.netPaise = cart.total_price - excludedFinal;
    if (cart.total_discount !== nativeAllocated || totalFinal > cart.total_price) result.otherDiscount = true;
    result.valid = true;
    if (!result.otherDiscount && candidates.length) result.confirmedGift = candidates[0];
    result.reason = result.otherDiscount ? 'other-discount' : result.confirmedGift ? 'native-discount-confirmed' : 'eligible-analysis';
    return result;
  }
  function decideGift(input) {
    input = input || {};
    var config = input.config || {};
    var preferences = input.preferences || {};
    var analysis = analyze(input.cart, config);
    var gifts = analysis.gifts;
    var selected = catalogue(config)[0] || null;
    var available = selected && selected.available === true && money(selected.pricePaise) && selected.pricePaise > 0;
    var threshold = money(config.thresholdPaise) ? config.thresholdPaise : THRESHOLD;
    var result = { status: 'NEEDS_RECOVERY', reason: analysis.reason, netPaise: analysis.netPaise,
      remainingRupees: remainingWholeRupees(analysis.netPaise, threshold), selectedVariantId: selected ? selected.variantId : null, actions: [] };
    function finish(status, reason, actions) {
      result.status = status; result.reason = reason; result.actions = actions || [];
      // Never send a positional or unresolved mutation for an unknown line key.
      if (result.actions.some(function (action) { return action.type !== 'ADD' && !action.lineKey; })) {
        result.status = 'NEEDS_RECOVERY'; result.reason = 'missing-line-key'; result.actions = [];
      }
      return result;
    }
    function remove(lines) { return lines.map(function (line) { return { type: 'REMOVE', lineKey: line.key, quantity: 0 }; }); }
    if (config.enabled !== true) return finish('DISABLED', 'campaign-disabled', remove(gifts));
    if (preferences.optedOut === true) return finish('OPTED_OUT', 'customer-opted-out', remove(gifts));
    if (!analysis.valid) return finish('NEEDS_RECOVERY', analysis.reason, remove(gifts));
    if (!selected || (!available && !gifts.length)) return finish('UNAVAILABLE', 'gift-unavailable');
    if (analysis.netPaise <= threshold) return finish('LOCKED', 'below-threshold', remove(gifts));
    if (preferences.recoveryRequired === true) return finish('CONFLICT', 'recovery-required', remove(gifts));
    if (analysis.otherDiscount) return finish('CONFLICT', 'other-discount', remove(gifts));
    if (gifts.length) {
      var chosen = analysis.confirmedGift || gifts[0];
      var cleanup = remove(gifts.filter(function (line) { return line !== chosen; }));
      if (chosen.quantity > 1) cleanup.push({ type: 'REDUCE', lineKey: chosen.key, quantity: 1 });
      if (cleanup.length) return finish('UPDATING', 'remove-duplicate-gifts', cleanup);
      if (chosen === analysis.confirmedGift) return finish('CONFIRMED', 'native-discount-confirmed');
      if (chosen.final_line_price > 0) return finish('CONFLICT', 'charged-gift', remove(gifts));
      return finish('NEEDS_RECOVERY', 'unverified-gift-discount', remove(gifts));
    }
    return finish('UPDATING', 'add-eligible-gift', [{ type: 'ADD', variantId: selected.variantId, quantity: 1 }]);
  }
  window.ApellaGiftCore = Object.freeze({ analyze: analyze, decideGift: decideGift });
})(window);
